export const ChapterShowcase = () => {
  const chapters = [
    {
      title: "The Mirror Ritual",
      commandment: "Face the truth. No filters. No lies. No mercy.",
      description: "Every morning at 4AM, you stand before the mirror and confess every broken promise out loud. You list every excuse. Every weakness. Every time you chose comfort over conquest. This is where discipline begins,  in brutal, bloody honesty. Most people can't do this for 7 days. You won't either. Prove me wrong."
    },
    {
      title: "The Calendar Crucifixion",
      commandment: "Mark your shame. Count your sins. Bleed in ink.",
      description: "Every failed day gets a blood-red X. Every kept promise gets a black check. No 'almost.' No 'tried my best.' By the end of the month, you'll have a calendar that shows you exactly who you are,  a warrior or a coward. The calendar doesn't lie. You do."
    },
    {
      title: "Execution Mode",
      commandment: "No thought. No hesitation. No negotiation. Only action.",
      description: "The 3-Second Rule that kills procrastination forever. When the impulse to act hits, you have exactly 3 seconds to move before your brain murders it with excuses. Get up. Speak. Execute. Hesitation is death. Move or rot."
    },
    {
      title: "The Dopamine Guillotine",
      commandment: "Kill your cravings or they kill you.",
      description: "Every scroll, every snack, every distraction is a hit of dopamine you didn't earn. This chapter teaches you to starve your brain into submission. Cut the feed. Reclaim control. Your attention is your currency. Stop giving it away for free."
    },
    {
      title: "The Shame Script",
      commandment: "Write your sins. Read them daily. Burn them when you're worthy.",
      description: "You will write down every promise you've broken. Every person you've let down. Every time you quit. Then you'll read it every single morning until you've bled enough to deserve burning it. Most people never burn it. Will you?"
    }
  ];

  return (
    <section className="py-24 bg-void relative">
      <div className="container mx-auto px-4 max-w-5xl">
        <h2 className="text-5xl md:text-6xl font-black text-center mb-4 tracking-tight">
          <span className="text-blood-bright">Chapter Showcase</span>
        </h2>
        <p className="text-center text-steel text-xl mb-20">Rituals as Scars</p>
        
        <div className="space-y-12">
          {chapters.map((chapter, index) => (
            <div 
              key={index}
              className="border-l-4 border-blood pl-8 py-6 bg-card/10 backdrop-blur-sm transition-all hover:border-blood-bright hover:bg-card/20"
            >
              <h3 className="text-3xl font-bold text-foreground mb-3 uppercase tracking-wide">
                {chapter.title}
              </h3>
              
              <p className="text-blood-bright text-xl font-semibold mb-4 italic">
                "{chapter.commandment}"
              </p>
              
              <p className="text-muted-foreground text-lg leading-relaxed">
                {chapter.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
